import DatabaseModel from './DatabaseModel.js';

var Sugerencia = Object.create(DatabaseModel);

Sugerencia.model = 'sugerencia';

export default Sugerencia;